import {PaperAirplaneIcon, AlertIcon} from '@primer/octicons-react'
import {IconButton} from '@primer/react'
import {useState, useRef} from 'react'
import {ScopedCommands} from '@github-ui/ui-commands'
import styles from './SteeringCommandInput.module.css'

// Maximum height for textarea in pixels, equivalent to approximately 6 lines
const MAX_TEXTAREA_HEIGHT_PX = 256

type SteeringCommandInputProps = {
  onSubmit: (message: string) => void
  error?: string | null
}

export function SteeringCommandInput({onSubmit, error}: SteeringCommandInputProps) {
  const [value, setValue] = useState('')
  const textareaRef = useRef<HTMLTextAreaElement>(null)

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setValue(e.target.value)

    // Auto-resize textarea to fit content
    const textarea = e.target
    textarea.style.height = 'auto'
    textarea.style.height = `${Math.min(textarea.scrollHeight, MAX_TEXTAREA_HEIGHT_PX)}px`
  }

  const handleSubmit = () => {
    if (value.trim()) {
      onSubmit(value)
      setValue('')
      // Reset textarea height
      if (textareaRef.current) {
        textareaRef.current.style.height = 'auto'
      }
    }
  }

  return (
    <ScopedCommands commands={{'copilot-chat:send-message': handleSubmit}}>
      <div className={styles.steeringCommandInputContainer}>
        <div className={styles.steeringCommandInputWrapper}>
          <textarea
            ref={textareaRef}
            className={styles.steeringCommandInputTextarea}
            value={value}
            onChange={handleChange}
            placeholder="What would you like to do next?"
            autoComplete="off"
            autoCorrect="on"
            rows={1}
          />
          <IconButton
            className={styles.steeringCommandInputSubmitButton}
            variant="invisible"
            size="small"
            icon={PaperAirplaneIcon}
            aria-label="Send"
            disabled={!value.trim()}
            onClick={handleSubmit}
          />
        </div>
        {error && (
          <div className={styles.errorMessage}>
            <AlertIcon className={styles.errorIcon} />
            <span>{error}</span>
          </div>
        )}
      </div>
    </ScopedCommands>
  )
}
